import type { AvatarProfileView, ConsentStatement } from '@alterium/shared';
import { api } from './client';

export const avatarApi = {
  get: () => api.get<AvatarProfileView>('/persona/avatar'),
  consentStatement: () => api.get<ConsentStatement>('/persona/avatar/consent-statement'),
  start: () => api.post<AvatarProfileView>('/persona/avatar'),
  submitConsent: (assetId: string, statementVersion?: string) =>
    api.post<AvatarProfileView>('/persona/avatar/consent', {
      assetId,
      ...(statementVersion ? { statementVersion } : {}),
    }),
  remove: () => api.delete('/persona/avatar'),
};
